import moment from 'moment';
import AdminTable from "../components/module/admin/AdminTable";
import AdminFilter from "../components/module/admin/AdminFilter";
import {SweetModal} from 'sweet-modal-vue'
import LpModal from '../components/module/common/LpModal.vue'
import AdminSimpleTable from '../components/module/admin/AdminSimpleTable';
import Structure from '../helper/structure-commerce'
import Const from '../utils/const.js'

export default {

  components: {
    AdminFilter,
    AdminTable,
    SweetModal,
    LpModal,
    AdminSimpleTable
  },

  created() {
    // tableData, filter_list 초기화
  },

  data() {
    return {
      tableData: [],
      filterData: [],
      filtered: {},
      filter_list: [],
      allCount: 0,
      filteredCount: 0,
      tableItems: [],
      structure_path:'',
      post_url:'',
      // 체크리스트
      checkArr: [],
      // 요청할 상태
      status: 0,
      // 변경할 상태값 목록
      status_arr: [],
      // 현재 탭
      selectedTab: 0,      // 0: 주문번호별, 1: 주문상품 번호별
    }
  },
  watch: {
    modalStatus(n) {
      if(n==='close' && this.post_url){
        this.getData(this.post_url);
      }
    }
  },
  computed: {
    path() {
      if (this.$store.getters.mode==='admin'){
        return this.$route.path.replace('/office/admin/','');
      }
      else if (this.$store.getters.mode==='partner'){
        return this.$route.path.replace('/office/partner/','');
      }
    }
  },

  methods: {
    // 체크박스 일괄 선택
    clickCheckBox(res) {
      if(res===true) {
        this.checkArr.forEach(item=> {
          item.value=true;
        })
      }
      else {
        this.checkArr.forEach(item=> {
          item.value=false;
        })
      }
    },
    // structre_path : 필터 데이터, 테이블 데이터
    // post_url : axios 호출할 post url
    initializing(structure_path, post_url, current_page) {
      this.structure_path = structure_path;
      this.post_url = post_url;
      this.setStructure(structure_path);
      this.initFiltered();
      this.getData();
      this.getStatusList(current_page);
    },
    setStructure(structure_path) {
      // structure.js 에서 경로에 맞는 데이터를 온다.
      this.filterData = Structure[structure_path+'_filter_data'];
      this.tableData = Structure[structure_path+'_table_data'];

    },
    initFiltered() {
      this.filtered = {
        cur_page: 1,
        page_num:1,
        total_page:1,
        page_length: 10
      };
    },

    // 내역 가져오기
    getData() {
      if(!this.post_url) return;
      this.$axios.get(this.getUrl(this.post_url), {
        params: this.filtered
      })
        .then(res => {
          if ( res.status === 200 ) {
            if ( res.data.data === undefined )
              this.tableItems = res.data;
            else
              this.tableItems = res.data.data;

            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;

            // 주문번호 탭
            if(this.selectedTab===0) {
              let tableList = [];
              for(let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].id, value: false });
              }
              this.checkArr = tableList;
            }
            // 상품 주문번호 탭
            else if(this.selectedTab===1) {
              // 체크리스트 추가
              let tableList = [];
              for (let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].id, value: false});
              }
              this.checkArr = tableList;
            }

            /* 테이블에 재조합 rowspan 추가 */
            this.initDeliveryTable();
          }
        }).catch(res => {});
    },

    // delivery package
    // 주문의 주문자, 배송비, 할인금액, 포인트등 order_id 주문 번호가 같을 경우 테이블 row 합쳐서 보여줌
    initDeliveryTable() {
      this.tableItems.forEach(item=> {
        item.rowspan = 0;
      })
      for(let i=0; i<this.tableItems.length; i++) {
        this.tableItems[i].rowspan = 1;
        let j = 0;
        for(j=i+1; j<this.tableItems.length; j++) {
          // 주문 번호가 같을 경우
          if(this.tableItems[i].order_id === this.tableItems[j].order_id) {
            this.tableItems[i].rowspan += 1;
          }
          // 주문 번호가 다를 경우
          else {
            break;
          }
        }
        i = j-1;
      }
    },

    selPageLength(length) {
      this.filtered.page_length = length;
      this.filtered.page_num = 1;
      this.getData();
    },

    ordering(res){
      this.filtered.ordering=res;
      this.getData();
    },

    // 상세페이지
    clickDetail(id){
      this.$router.push(this.getPath(`commerce/download/detail?id=${id}`));
    },

    // 상태값 목록
    getStatusList(current_page){
      //console.log('sdasda')
      this.$axios.get(this.getUrl(`commerce/order/status?page=${current_page}`)).then(res=>{
        if(res.status === 200){
          this.status_arr = res.data;
        }
      })
    },

    // 결제 상태
    payStatus(status){
      if(status>=101) return '결제완료';
      else return '미결제'
    },

    // 주문 상태
    // convertStatusType(st){
    //   return Const['ko_purchase'][st]
    // },

    convertPayType(name){
      let value = '';
      switch(name) {
        case 'credit':
          value='신용카드';
          break;
        case 'phone':
          value='휴대폰';
          break;
        case 'vbank':
          value='무통장';
          break;
        case 'trans':
          value='실시간 계좌이체';
          break;
      }
      return value;
    },

    saveData (modal_name) {
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;

      let url = '';
      if(this.selectedTab===0) url = 'commerce/order/status/change';
      else if(this.selectedTab===1) url = 'commerce/orderproduct/status/change';
      this.$store.commit('setLoading', true);
      this.$axios.post(this.getUrl(url),{
        status: this.status,
        checked: id_list
      }).then(res=>{
        if(res.status===200){
          this.toast('처리가 완료되었습니다.');
          if(this.$route.query.id) {
            this.getDetail();
          }
          else {
            this.getData();
          }
          this.$store.commit('setLoading', false);
          if(modal_name) this.$modal.hide(modal_name);
        }
      }).catch(error => {
        this.$store.commit('setLoading', false);
        if (error.response) {
          this.toast(error.response.data.message);
        }
      })
    },

    // 일괄 상태 변경
    clickChange(){
      this.status = parseInt(this.status);
      // // 취소요청, 취소완료시 모달 띄워서 확인하기
      if(this.status===504) {
        this.openModal('cancelModal');
      }
      // 취소 요청 철회
      else if(this.status===505) {
        this.openModal('cancelModal');
      }
      // 교환요청 철회
      else if(this.status===610) {
        this.openModal('cancelExchangeModal')
      }
      // 반품 완료
      else if(this.status===705) {
        this.openModal('refundModal');
      }
      // 반품 철회
      else if(this.status===706) {
        this.openModal('cancelRefundModal');
      }
      else this.saveData();
    },

    // 모달 확인시
    confirmModal(modal_name){
      this.saveData(modal_name);
    },

    // 단일 상태 변경
    statusChange(id, status) {
      let url = 'commerce/orderproduct/status/change';
      this.$axios.post(this.getUrl(url), {
        id: id,
        status: status
      }).then(res=> {
        if(res.status===200) {
          this.toast('상태가 변경되었습니다.');
          if(this.$route.query.id) {
            this.getDetail();
          }
          else {
            this.getData();
          }
        }
      })
    },

    //  체크된 id들 가져오기
    getCheckedArr(){
      let id_list = [];
      for(let i=0; i<this.checkArr.length; i++){
        if(this.checkArr[i].value){
          id_list.push(this.checkArr[i].id);
        }
      }

      return id_list;
    },

    openModal (modal_name) {
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;
      this.$modal.show(modal_name);
    },

    autoHyphenPhone(str) {
      str = str.replace(/[^0-9]/g, '');
      var tmp = '';

      if (str.substr(0, 2) == '02') {
        if (str.length < 3) {
          return str;
        } else if (str.length < 6) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2);
          return tmp;
        } else if (str.length < 10) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 3);
          tmp += '-';
          tmp += str.substr(5);
          return tmp;
        } else {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 4);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        }
      }
      else {
        if (str.length < 4) {
          return str;
        } else if (str.length < 7) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3);
          return tmp;
        } else if (str.length < 11) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 3);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        } else {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 4);
          tmp += '-';
          tmp += str.substr(7);
          return tmp;
        }
      }
      return str;
    },
    optionFullName(option) {
      return `${option.option.name}: +${option.option.price}원 / ${option.quantity}개`;
    },
  }
}
